import { makeCloudFunction } from "../makeCloudFunction";
import { Type } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";

export type { Type };
export const listTypes = makeCloudFunction<void, Type[]>("type", "listTypes");
export const useListTypes = makeUseCloudFunction(listTypes);
